/**
 * @generated SignedSource<<20b6543d38f2c053dffb5666c42f8851>>
 * @relayHash 0c23c64ed576f3d7b679ecc331d1c368
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dfd336ff6cfd9234af42873b11f775ab106d4fac2b9a79e67e17cd832a0b167a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { main_getIssueTransitionByIdRootQuery } from './main_getIssueTransitionByIdRootQuery.graphql';

import isFCFAccessNarrowingEnabled_provider from '@atlassian/jira-relay-provider/src/fcf-its-with-access-narrowing.relayprovider';
import includeEgressOverridesForge_provider from '@atlassian/jira-relay-provider/src/forge-query-include-egress-overrides.relayprovider';
import includeUserAccessEnabledForge_provider from '@atlassian/jira-relay-provider/src/forge-query-include-user-access-enabled.relayprovider';
import includeUserAccess_provider from '@atlassian/jira-relay-provider/src/forge-query-include-user-access.relayprovider';
import isNikeChinMigrateMultiSelectEditViewDeprecatedEnabled_provider from '@atlassian/jira-relay-provider/src/nike-chin-migrate-multi-select-edit-view-deprecated.relayprovider';

const node: PreloadableConcreteRequest<main_getIssueTransitionByIdRootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "dfd336ff6cfd9234af42873b11f775ab106d4fac2b9a79e67e17cd832a0b167a",
    "metadata": {},
    "name": "main_getIssueTransitionByIdRootQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcforgequeryincludeuseraccessrelayprovider": includeUserAccess_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcfcfitswithaccessnarrowingrelayprovider": isFCFAccessNarrowingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcforgequeryincludeegressoverridesrelayprovider": includeEgressOverridesForge_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcforgequeryincludeuseraccessenabledrelayprovider": includeUserAccessEnabledForge_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinmigratemultiselecteditviewdeprecatedrelayprovider": isNikeChinMigrateMultiSelectEditViewDeprecatedEnabled_provider
    }
  }
};

export default node;
